package com.wintermar.inspection.core.ui.component.image.util.event_listener

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

class UploadFileListenerImpl : UploadFileListener {
    private val _events = MutableSharedFlow<UploadFileEvent>()
    override val events = _events.asSharedFlow()

    override suspend fun emit(event: UploadFileEvent) {
        _events.emit(event)
    }
}
